'use client';

import React from 'react';
import { ThemeProvider } from 'next-themes';
import { Provider as ReduxProvider } from 'react-redux';
import { store } from '@/redux/store';
import GlobalWrapper from '@/components/landing/layout/global-wrapper';

const initialState = store.getState();
const serverState: typeof initialState = {
  ...initialState,
  auth: { ...initialState.auth, accessToken: null, refreshToken: null }
};

type ProvidersProps = {
  children: React.ReactNode;
};

export default function Providers({ children }: Readonly<ProvidersProps>) {
  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
      <ReduxProvider store={store} serverState={serverState}>
        <GlobalWrapper>{children}</GlobalWrapper>
      </ReduxProvider>
    </ThemeProvider>
  );
}
